var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile app-container"},[_c('v-row',{staticClass:"mx-0"},[_c('div',{attrs:{"id":"profile-menu"}},[_c('profile-menu',{on:{"logout":_vm.logout}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }